import(/* webpackMode: "eager" */ "/vercel/path0/app/apply/np/page.tsx");
